// Shared employee selection for report screens.
// The component provides `baseEmployees` (employees after its own filters, before the name / IC search),
// `selectedEmployees` and `searchInput` (`searchIC` is optional).
// Searching never drops a selection; changing any other filter asks before removing selections it excludes.
const SELECTION_FILTER_KEYS = ['filters', 'isActive', 'startDate', 'endDate']

const emptySelectionRemoval = () => ({ employees: [], previousFilters: null })

export default {
  data () {
    return {
      selectionRemoval: emptySelectionRemoval(),
      restoringSelectionFilters: false,
    }
  },

  computed: {
    filteredEmployees () {
      const name = (this.searchInput || '').trim().toLowerCase()
      const ic = (this.searchIC || '').trim().toLowerCase()

      return this.baseEmployees.filter(employee => {
        const person = employee.person || {}
        const identityCard = person.identity_card || {}

        const matchesName = (person.name || '').toLowerCase().includes(name)
        const matchesIC = (identityCard.ic_number || '').toLowerCase().includes(ic) ||
          (identityCard.passport_number || '').toLowerCase().includes(ic)

        return matchesName && matchesIC
      })
    },

    selectionFilterSnapshot () {
      const snapshot = {}

      SELECTION_FILTER_KEYS
        .filter(key => key in this.$data)
        .forEach(key => {
          snapshot[key] = this[key]
        })

      return JSON.stringify(snapshot)
    },
  },

  watch: {
    selectionFilterSnapshot (value, oldValue) {
      if (this.restoringSelectionFilters) {
        this.restoringSelectionFilters = false
        return
      }

      const includedUids = new Set(this.baseEmployees.map(employee => employee.employee_uid))
      const excludedEmployees = this.selectedEmployees.filter(employee => !includedUids.has(employee.employee_uid))

      if (!excludedEmployees.length) return

      this.selectionRemoval = {
        employees: excludedEmployees,
        previousFilters: oldValue,
      }
    },
  },

  methods: {
    setSelectedEmployees (employees) {
      this.$validator.pause()

      this.selectedEmployees = employees

      this.$nextTick(() => {
        this.$validator.resume()
      })
    },

    confirmSelectionRemoval () {
      const removedUids = new Set(this.selectionRemoval.employees.map(employee => employee.employee_uid))

      this.setSelectedEmployees(this.selectedEmployees.filter(employee => !removedUids.has(employee.employee_uid)))
      this.selectionRemoval = emptySelectionRemoval()
    },

    cancelSelectionRemoval () {
      const previousFilters = JSON.parse(this.selectionRemoval.previousFilters)

      this.restoringSelectionFilters = true
      Object.keys(previousFilters).forEach(key => {
        this[key] = previousFilters[key]
      })

      this.selectionRemoval = emptySelectionRemoval()
    },
  },
}
